import { createContext } from "react";

export interface StytchConfig {
  enabled: boolean;
  environment: "production" | "development";
  consumerPublicToken: string | undefined;
  b2bPublicToken: string | undefined;
}

export const StytchConfigContext = createContext<StytchConfig | null>(null);
